import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./translate.css";

const languages = [
  { code: "en", name: "English", flag: "https://flagcdn.com/w20/gb.png" },
  { code: "fr", name: "Français", flag: "https://flagcdn.com/w20/fr.png" },
  { code: "ar", name: "عربية", flag: "https://flagcdn.com/w20/sa.png" },
  { code: "es", name: "Español", flag: "https://flagcdn.com/w20/es.png" },
  { code: "pt", name: "Português", flag: "https://flagcdn.com/w20/pt.png" },
  { code: "dt", name: "Deutsch", flag: "https://flagcdn.com/w20/de.png" },
];

// Function to determine font size based on screen width
const getFontSize = () => {
  if (window.innerWidth < 480) return "0.8rem";
  if (window.innerWidth < 768) return "0.9rem";
  if (window.innerWidth < 1024) return "1rem";
  return "1.1rem";
};

function Translate() {
  const { i18n } = useTranslation();
  const [selectedOption, setSelectedOption] = useState(i18n.language);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedOption(i18n.language);
  }, [i18n.language]);

  const handleChange = (code) => {
    setSelectedOption(code);
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="text-white" ref={dropdownRef} style={{ position: "relative" }}>
      <div
        className="language-selector"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <img
          src={languages.find((lang) => lang?.code === selectedOption)?.flag}
          alt={selectedOption}
          style={{ width: "24px", borderRadius: "2px" }}
        />
        <div
          className="language-button"
          style={{
            display: "flex",
            alignItems: "center",
            color: "white",
            fontSize: getFontSize(),
            fontWeight: "bold",
            paddingLeft: 10,
            paddingRight: 20,
            position: "relative",
          }}
        >
          {languages.find((lang) => lang?.code === selectedOption)?.name}
          <span
            style={{
              position: "absolute",
              right: 0,
              width: 10,
              height: 6,
              backgroundImage:
                "url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2214%22 height=%229%22 viewBox=%220 0 14 9%22%3E%3Cpath fill=%22%23FFF%22 fill-rule=%22evenodd%22 d=%22M7 9L0 0h14L7 9z%22/%3E%3C/svg%3E')",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
            }}
          />
        </div>
      </div>

      {isOpen && (
        <div
          className="dropdown-menu show"
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            left: "auto",
            zIndex: 1000,
            minWidth: "180px",
            padding: "8px 0",
            background: "#121A25",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "8px",
            marginTop: "8px"
          }}
        >
          {languages.map((lang) => (
            <button
              key={lang.code}
              className="dropdown-item"
              onClick={() => handleChange(lang.code)}
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                padding: "10px 16px",
                background: "transparent",
                border: "none",
                color: "white",
                textAlign: "left",
                cursor: "pointer"
              }}
            >
              <img
                src={lang.flag}
                alt={lang.name}
                style={{ width: "24px", marginRight: "12px", borderRadius: "2px" }}
              />
              <span style={{ fontSize: "16px" }}>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default Translate;
